var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSelectLayer22 = function SvgIconSelectLayer22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    clipPath: "url(#icon_select_layer_22_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.996.917q.913.013 1.659.04m-5.806 0Q5.594.93 6.508.918M1.2 2.362c.21-.534.628-.952 1.16-1.162M.919 6.509q.013-.914.04-1.659m0 5.8a74 74 0 0 1-.04-1.658m1.443 5.31A2.05 2.05 0 0 1 1.2 13.138M14.304 2.362A2.06 2.06 0 0 0 13.143 1.2M18.313 9.625A60 60 0 0 0 18.2 6.93a2.275 2.275 0 0 0-2.146-2.146 69 69 0 0 0-4.562-.134c-2.007 0-3.51.063-4.563.134a2.275 2.275 0 0 0-2.146 2.146 69 69 0 0 0-.134 4.562c0 2.007.064 3.51.134 4.563A2.275 2.275 0 0 0 6.928 18.2c.697.047 1.59.09 2.697.114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.658 15.412c.108-.045.177-.065.242-.13a.34.34 0 0 0 0-.483c-.064-.064-.086-.103-.242-.149-.157-.046-7.752-2.613-7.752-2.613a.685.685 0 0 0-.87.869s2.63 7.648 2.661 7.752a.55.55 0 0 0 .138.242.34.34 0 0 0 .484 0c.064-.064.08-.1.127-.242.048-.142 1.343-3.873 1.343-3.873s3.76-1.328 3.869-1.373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_select_layer_22_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgIconSelectLayer22;